import { AppState } from "@pmis3/data-access";
import { VesselStopState, VesselStopStateStatus } from "../reducer/vesselStop.reducer";
import { createSelector } from "@ngrx/store";

export const vesselStopState = (state: AppState) => state.vesselStopState;

export const selectVesselStops = createSelector(
    vesselStopState,
    (state: VesselStopState) => {
        console.log("state: ", state)
        return state.status === VesselStopStateStatus.SUCCESS ? state.vesselStops?.items : [];
    }
)

export const selectVesselStopStateStatus = createSelector(
  vesselStopState,
  (state: VesselStopState) => state.status
)